import { UserImport } from 'app/import/user-import.model';
import { UserMapper } from 'app/user/user.mapper';
import { ErrorParser } from 'app/import/import-error/error.parser';

export class UserImportMapper {
  public static map(importUserData: any): UserImport {
    if (!importUserData) {
      return null;
    }

    return new UserImport (
      UserMapper.map(importUserData.user),
      ErrorParser.parse(importUserData.errors)
    );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/import/user-import.mapper.ts